import { getTheme } from "@clipboard-health/ui-theme";
import { ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useState } from "react";

import { ConfirmPhonePage } from "../../Accounts/ConfirmPhonePage/Page";
import { SignNewAgreementPageContainer } from "./SignNewAgreementPageContainer";

export function SignNewAgreementPage() {
  const [isAuthorized, setIsAuthorized] = useState(false);

  return (
    <ThemeProvider theme={getTheme()}>
      {isAuthorized ? (
        <SignNewAgreementPageContainer />
      ) : (
        <ConfirmPhonePage
          title="Sign New Agreement"
          requestOtpEventName={APP_V2_USER_EVENTS.SIGN_NEW_AGREEMENT_SEND_OTP}
          fallbackGoBackPath="/"
          onSuccess={() => {
            setIsAuthorized(true);
          }}
        />
      )}
    </ThemeProvider>
  );
}
